import { ASSIGNMENT_AGENT_STATUS } from 'common/constants'
import format from 'date-fns/format'
import parse from 'date-fns/parse'

export const getMetroFromZip = (zip) => {
  if (zip.borough) {
    if (zip.neighborhoods.length > 0) {
      return `${zip.borough} - ${zip.neighborhoods.join(', ')}`
    } else {
      return `${zip.borough}`
    }
  } else {
    return zip.metro
  }
}

export const estimatedCommission = (closeAmount = 0, isLease) => {
  return !isLease && closeAmount > 0 ? parseFloat((closeAmount * .03).toFixed(2)) : null
}

export const toCurrency = num => {
  return num ? "$" + num.toLocaleString() : ""
}

export const fromCurrency = numStr => {
  return parseInt((numStr || "0").replace(/\$/,"").replace(/,/g,""))
}

export const getStatusOrder = status => ASSIGNMENT_AGENT_STATUS.findIndex(({ value }) => value === status)

export const compareStatus = (left, right) => getStatusOrder(left) - getStatusOrder(right)

export const scrollToTop = () => {
  window.scrollTo(0, 0)
  document.body.scrollTop = 0
}

export const getFormattedTourDateTime = (isScheduled, requestedDate, requestedTimeframe, scheduledDate) => {
  if (isScheduled) {
    return format(new Date(scheduledDate), 'MMMM D [at][\n]h:mm a')
  }

  const formattedRequestDate = format(parse(requestedDate), 'MMMM D')
  return `${formattedRequestDate}\n${requestedTimeframe || 'Anytime'}`
}

export const getFormattedTourDate = (isScheduled, requestedDate, scheduledDate) => {
  if (isScheduled) {
    return format(new Date(scheduledDate), 'MMMM D')
  }

  return format(parse(requestedDate), 'MMMM D')
}
